<template>
  <div>
    <!--<v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>-->
    <v-container v-if="article && article.page">
      <div class="page-content">
        <div class="page-content-head">
          <h1 class="title-page" v-if="!article.page.hide_title">{{ article.page.transTitle}}</h1>
          <div class="indicator-3">
            <span class="green"></span>
            <span class="red-light"></span>
            <span class="red"></span>
          </div>
        </div>
        <div class="page-content-body">
          <div class="blog-pg" v-if="article.children">
            <div class="blog-item" v-for="child in article.children">
              <div class="blog-image" v-if="child.transFile">
                <img :src="baseUrl+child.transFullFilesDirectory" alt="">
              </div>
              <div class="blog-data">
                <h1>
                  <router-link
                    tag="a"
                    :to="{ name: 'article', params: { slug: child.slug }}"
                    :key="child.id"
                  >{{child.transTitle}}
                  </router-link>
                </h1>
                <div>{{child.transContent | strippedSliceContent}}...</div>
                <div class="blog-footer">
                  <div class="date">{{ new Date(child.publish_date) | dateFormat('DD.MM.YYYY') }}</div>
                  <div>
                    <router-link
                      tag="a"
                      :to="{ name: 'article', params: { slug: child.slug }}"
                      :key="child.id"
                      class="read-more"
                    >Подробнее...
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import CMS from '@/model/cms'

  export default {
    components: {},
    data: () => ({
      article: null,
      breadcrumbs: [],
      baseUrl: process.env.VUE_APP_BACK_URL
    }),
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        CMS.loadBlogBySlug(this.$route.params.slug)
          .then(response => {
            this.article = response.data
            this.breadcrumbs = [
              {
                text: 'Главная',
                disabled: false,
                href: '/'
              },
              {
                text: this.article.transTitle,
                disabled: true
              }
            ]
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    mounted () {
      this.fetchData()
    }
  }
</script>
